module.exports = __webpack_public_path__ + "img/cat-banner-catalogue.2f914227.svg";